import React from 'react';
import { Button as MUIButton, CircularProgress } from '@material-ui/core';

export default function Button({ children, loading = false, loadingProps, ...buttonProps }) {
  if (loading) {
    buttonProps.disabled = true;
  }

  return (
    <MUIButton disableElevation color="primary" size="large" variant="contained" {...buttonProps}>
      {Boolean(loading) && (
        <>
          <CircularProgress color="primary" size={20} {...loadingProps} />
          &nbsp;&nbsp;
        </>
      )}
      {children}
    </MUIButton>
  );
}
